var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('Modal', {
    attrs: {
      "loading": _vm.loading,
      "width": "400px",
      "title": $t("axh2dh6", "二次确认登录"),
      "mask-closable": false
    },
    on: {
      "on-ok": _vm.login
    },
    model: {
      value: _vm.secondCheck.show,
      callback: function ($$v) {
        _vm.$set(_vm.secondCheck, "show", $$v);
      },
      expression: "secondCheck.show"
    }
  }, [_c('div', {
    staticClass: "second"
  }, [_c('SendMessage', {
    ref: "sendMessage",
    attrs: {
      "accountType": _vm.secondCheck.accountType,
      "mode": "SECOND_CONFIRM",
      "exist": true
    },
    model: {
      value: _vm.secondCheck,
      callback: function ($$v) {
        _vm.secondCheck = $$v;
      },
      expression: "secondCheck"
    }
  })], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };